import * as React from 'react'

export type SelectedScheduleType = {
  scheduleId: number
  time: string
}
type AssignToWorkTableContextType = {
  shiftKeyDown: boolean
  selectedSchedules: SelectedScheduleType[]
  setSelectedSchedules: (selectedSchedules: SelectedScheduleType[]) => void
}
export const AssignToWorkTableContext = React.createContext<AssignToWorkTableContextType>({
  shiftKeyDown: false,
  selectedSchedules: [],
  setSelectedSchedules: () => ({}),
})
